import AppFooter from './app-footer';

export default AppFooter;
